<template>
  <ul class="multi-select-container">
    <li>
      <v-btn
        :outlined="rewardsAppliedFilters.length > 0"
        :style="rewardsAppliedFilters.length === 0
          ? activeStyle
          : inactiveStyle
        "
        class="filter-button"
        @click="filterBounties('all')"
      >
        {{ $t('bounties.rewardsOverviewSelectAll') }}
      </v-btn>
    </li>
    <template v-if="filterOptions.length > 0">
      <li
        v-for="option in filterOptions"
        :key="option.value"
      >
        <v-btn
          :outlined="!isOptionActive(option.value)"
          :style="isOptionActive(option.value)
            ? activeStyle
            : inactiveStyle
          "
          class="filter-button"
          @click="filterBounties(option.value)"
        >
          {{ option.name }}
        </v-btn>
      </li>
    </template>
  </ul>
</template>

<script>
import _ from 'lodash'
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  props: {
    filterData: {
      type: Object,
      required: true,
    },
    customStyle: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      fieldData: [],
    }
  },
  computed: {
    ...mapState(['rewardsAppliedFilters']),
    ...mapGetters(['extensionSettings']),
    attribute() {
      return _.get(this.filterData, 'attribute', '')
    },
    type() {
      return _.get(this.filterData, 'type', '')
    },
    modelType() {
      return this.getAttributePart(0)
    },
    modelPath() {
      return this.getAttributePart(1)
    },
    modelKey() {
      return this.getAttributePart(2)
    },
    filterOptions() {
      return _.get(this.fieldData, 'options', [])
    },
    activeStyle() {
      return _.get(this.customStyle, 'active', {})
    },
    inactiveStyle() {
      return _.get(this.customStyle, 'inactive', {})
    },
  },
  async mounted() {
    this.$emit('registered-filter', {
      attribute: this.attribute,
    })
    await this.getFilterOptions()
    this.applyFilters()
  },
  methods: {
    ...mapMutations([
        'addRewardsAppliedFilter',
        'deleteRewardsAppliedFilter',
        'clearRewardsAppliedFilters'
    ]),
    ...mapActions(['fetchCmsModel']),
    getAttributePart(index) {
      if (_.isEmpty(this.attribute)) {
        return ''
      }

      const attributeParts = this.attribute.split('.')

      if (attributeParts.length < index + 1) {
        return ''
      }

      return this.attribute.split('.')[index]
    },
    async getFilterOptions() {
      if (this.modelType === 'cms') {
        try {
          const response = await this.fetchCmsModel(this.modelPath)
          const fields = _.get(response, 'definition.fields', [])
          const foundField = fields.find((field) => {
            return field.key === this.modelKey
          })

          if (foundField) {
            this.fieldData = foundField
          }
        } catch (error) {
          console.log(error)
        }
      }
    },
    isOptionActive(optionValue) {
      return this.rewardsAppliedFilters.includes(optionValue)
    },
    filterBounties(filterValue) {
      const isFilterAlreadyApplied = filterValue === 'all'
        ? this.rewardsAppliedFilters.length === 0
        : this.rewardsAppliedFilters.includes(filterValue)

      if (filterValue === 'all') {
        if (isFilterAlreadyApplied) {
          return
        } else {
          this.clearRewardsAppliedFilters()
        }
      } else {
        if (isFilterAlreadyApplied) {
          this.deleteRewardsAppliedFilter(filterValue)
        } else {
          this.addRewardsAppliedFilter(filterValue)
        }
      }

      this.applyFilters()
    },
    applyFilters() {
      this.$emit('applied-filter', {
        attribute: this.attribute,
        options: this.rewardsAppliedFilters,
        type: this.type
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.multi-select-container {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;

  li {
    list-style-type: none;
    margin: 0 10px 10px 0;

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
